import $ from 'jquery';

$(document).ready(function() {
  var textArea = $('textarea#narx_request_xml');
  if (!textArea.length) return;
  if (!window.CodeMirror) return;

  var mode = textArea.data('mode');
  var modeSetting;

  if (mode === 'json') {
    modeSetting = { name: "javascript", jsonld: true };
  } else {
    modeSetting = 'xml';
  }

  var codeMirror = window.CodeMirror.fromTextArea(textArea.get(0), {
    lineNumbers: true,
    mode: modeSetting,
    theme: 'abcdef',
  });

  codeMirror.setSize(1200, 750);

  function formatJSON(data) {
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }
    return JSON.stringify(data, null, 2);
  }

  function getCodeMirrorJSON() {
    try {
      return JSON.parse(codeMirror.getValue());
    } catch (e) {
      return null;
    }
  }

  function setCodeMirrorJSON(data) {
    codeMirror.setValue(formatJSON(data));
  }

  if (mode === 'json') {
    var parsed = getCodeMirrorJSON();
    if (parsed !== null) {
      setCodeMirrorJSON(parsed);
    }
  }
});
